export const VERSION = "1.1.0";
export const STORAGE_KEY_PREFIX = `ptcgdex.${VERSION}`;
export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string) ?? "http://localhost:3000";
